import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { SystemService } from 'src/app/services/system.service';

@Component({
  selector: 'app-modal-qr-code',
  templateUrl: './modal-qr-code.component.html',
  styleUrls: ['./modal-qr-code.component.scss'],
})
export class ModalQrCodeComponent implements OnInit, OnDestroy {
  @Input() data: any;
  @ViewChild('conteudoInput') conteudoInput!: ElementRef<HTMLInputElement>;
  interval: any;

  constructor(private modalCrtl: ModalController, private toastCtrl: ToastController, private service: SystemService) { }

  ngOnInit() {
    this.startGetByMinute();
  }
  async copiarConteudo() {
    try {
      await navigator.clipboard.writeText(this.conteudoInput.nativeElement.value);
      this.atualizarBotaoCopiar();
    } catch (error) {
      console.error('Falha ao copiar: ', error);
    }
  }

  async atualizarBotaoCopiar() {
    const btn = document.getElementById('btnCopiar');
    this.showMessage('Codigo QR Copiado');
    if (btn) {
      btn.textContent = 'Copiado!';
      btn.style.backgroundColor = 'black';
      btn.style.color = 'white';
      setTimeout(() => {
        btn.textContent = 'Copiar Código QR';
        btn.style.backgroundColor = '#007bff';
        btn.style.color = '#fff';
      }, 3000);
    }
  }

  async checkPay(){
    this.service.checkPayUser(this.data.txId).subscribe(result => {
      if(result.success){
        this.showMessage(result.message);
        this.close();
      }
    });
  }

  async startGetByMinute() {
    this.interval = setInterval(async () => {
      await this.checkPay();
    }, 3000);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  close() {
    this.modalCrtl.dismiss();
  }

  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen, duration: 3000 });
    error.present();
  }

}
